export const clearAllCaches = async (): Promise<void> => {
  // Clear version manually instead of nuking all localStorage
  localStorage.removeItem("version");

  if ("caches" in window) {
    const names = await caches.keys();
    await Promise.all(names.map((name) => caches.delete(name)));
  }

  if (navigator.serviceWorker) {
    const registrations = await navigator.serviceWorker.getRegistrations();
    await Promise.all(registrations.map((r) => r.unregister()));
  }
};

const showUpdateNotification = (): Promise<null> => {
  const toast = document.createElement("div");
  toast.style.cssText = `
    position: fixed;
    top: 20px;
    right: 20px;
    background: #fff;
    color: #002558;
    padding: 12px 16px;
    border-radius: 8px;
    font-family: 'Ford Antenna', sans-serif;
    font-size: 14px;
    z-index: 9999;
    box-shadow: 0 4px 12px rgba(0,0,0,0.15);
    transform: translateX(100%);
    transition: transform 0.3s ease;
  `;
  toast.textContent = "🔄 Updating to latest version...";
  document.body.appendChild(toast);
  setTimeout(() => (toast.style.transform = "translateX(0)"), 100);
  return new Promise((resolve) =>
    setTimeout(() => {
      toast.style.transform = "translateX(100%)";
      setTimeout(() => {
        document.body.removeChild(toast);
        resolve(null);
      }, 300);
    }, 2000),
  );
};

export async function manageCacheAndVersion(): Promise<void> {
  const version = import.meta.env.VITE_GITHUB_SHA || "(not set)";
  const lsVersion = localStorage.getItem("version") || "(not set)";
  console.log(`App version: ${version} / Cached: ${lsVersion}`);

  if (
    version !== "(not set)" &&
    lsVersion !== "(not set)" &&
    lsVersion !== version
  ) {
    await clearAllCaches();
    await showUpdateNotification();
    localStorage.setItem("version", version);
    window.location.reload();
  }
}
